import * as t from "./types";
import * as actions from "./action";

/* User */
export const getUserAction = (
  payload: t.GetUserRequestType
): t.GetUserActionType => {
  return {
    type: actions.GET_USER,
    payload,
  };
};

export const getUsersAction = (
  payload: t.GetUsersRequestType
): t.GetUsersActionType => {
  return {
    type: actions.GET_USERS,
    payload,
  };
};

export const addUserAction = (
  payload: t.CreateUserRequestType
): t.AddUserActionType => {
  return {
    type: actions.ADD_USER,
    payload,
  };
};

export const modifyUserAction = (
  payload: t.ModifyUserRequestType
): t.ModifyUserActionType => {
  return {
    type: actions.MODIFY_USER,
    payload,
  };
};

export const deleteUserAction = (
  payload: t.DeleteUserRequestType
): t.DeleteUserActionType => {
  return {
    type: actions.DELETE_USER,
    payload,
  };
};

export const getCurrentUserAction = (
  payload: t.GetCurrentUserRequestType
): t.GetCurrentUserActionType => {
  return {
    type: actions.GET_CURRENT_USER,
    payload,
  };
};

export const changePasswordCurrentUserAction = (
  payload: t.CurrentUserChangePasswordRequestType
): t.ChangePasswordCurrentUserActionType => {
  return {
    type: actions.CHANGE_PASSWORD_CURRENT_USER,
    payload,
  };
};
